// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"SimilarContent_sectionWrapper__hdqYh","contentWrapper":"SimilarContent_contentWrapper__DpXZb","cardListWrapper":"SimilarContent_cardListWrapper__rvp+1"};